import { FunctionComponent } from 'react'

import useIsEndOfArticle from '@hooks/useIsEndOfArticle'
import usePageMetadata from '@hooks/usePageMetadata'
import DesktopGamificationButton from '@components/Buttons/GamificationButton/DesktopGamificationButton'
import MobileGamificationButton from '@components/Buttons/GamificationButton/MobileGamificationButton'

const GamificationButton: FunctionComponent = () => {
  const { gamification } = usePageMetadata()
  const endOfArticle = useIsEndOfArticle()

  if (gamification?.active) {
    return (
      <>
        <DesktopGamificationButton {...gamification} />
        {!endOfArticle && <MobileGamificationButton {...gamification} />}
      </>
    )
  }

  return null
}

export default GamificationButton
